import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    max-width: 1140px;
    margin: auto;

    > * {
        margin-top: 5em;

        &:first-of-type {
            margin-top: 0;
        }
    }
`;
